import { BoardsApiKanbanLane, KanbanLane } from '../../model/board-view/kanban-area/kanban-lane';
import { ACTION_STATUS, ACTION_STATUS_CAMEL_CASE } from '../../services/backend-service/model/action-status';

const actionStatusCamelCaseToUppercase = {
  [ACTION_STATUS_CAMEL_CASE.NOTSET]: ACTION_STATUS.NOTSET,
  [ACTION_STATUS_CAMEL_CASE.SUGGESTION]: ACTION_STATUS.SUGGESTION,
  [ACTION_STATUS_CAMEL_CASE.DECIDED]: ACTION_STATUS.DECIDED,
  [ACTION_STATUS_CAMEL_CASE.INPROGRESS]: ACTION_STATUS.INPROGRESS,
  [ACTION_STATUS_CAMEL_CASE.COMPLETED]: ACTION_STATUS.COMPLETED,
  [ACTION_STATUS_CAMEL_CASE.CANCELLED]: ACTION_STATUS.CANCELLED,
};

export function toClientActionStatuses(swimlanes: BoardsApiKanbanLane[]): KanbanLane[] {
  return swimlanes.map((s) => ({
    id: s.id,
    title: s.title,
    ...(s.type ? { type: actionStatusCamelCaseToUppercase[s.type] } : {}),
  }));
}
